
angular.module('charts', []);